import { defineMessages } from 'react-intl';

export const newFolderMessages = defineMessages({
  newFolderButton: {
    id: 'new_folder.new_folder_button',
    defaultMessage: 'Create a folder',
    description: 'Title page',
  },
  titlePage: {
    id: 'new_folder.title_page',
    defaultMessage: 'New folder',
    description: 'Title page',
  },
  title: {
    id: 'new_folder.title',
    defaultMessage: 'Import PDF files',
    description: 'PDF section title',
  },
  pdfFilesRequired: {
    id: 'new_folder.pdf_files_required',
    defaultMessage: 'At least one PDF file is required',
    description: 'Error message when no PDF file is selected',
  },
  pdfFilesTypeError: {
    id: 'new_folder.files_type_error',
    defaultMessage: 'Only PDF files are accepted',
    description: 'Error message when non-PDF files are selected',
  },
  pdfFilesSizeError: {
    id: 'new_folder.files_size_error',
    defaultMessage: 'Files must not exceed 10 MB each',
    description: 'Error message when files are too large',
  },
  description: {
    id: 'new_folder.description',
    defaultMessage: '<b>Import from your files</b>\u000aor drag and drop',
    description: 'Drop zone instruction text',
  },
  liteDescription: {
    id: 'new_folder.lite_description',
    defaultMessage: '<b>Import</b> or drag and drop',
    description: 'Drop zone instruction text',
  },
  redirectionMessage: {
    id: 'new_folder.redirection_message',
    defaultMessage: 'You will be redirected to the list of folders.',
    description: 'Redirection message after submitting the form',
  },
});
